window.addEventListener('DOMContentLoaded', initHeader);
function initHeader() {
  const header = document.querySelector("#main-header");
  if (!header) return;
  const mobileMenuToggle = header.querySelector("#mobile-menu-toggle");
  const mainMenuItems = document.querySelectorAll("#main-menu .menu-item, #mobile-menu .menu-item, #main-flyout .menu-item");
  const flyout = document.querySelector("#main-flyout");
  const flyoutItems = flyout?.querySelectorAll("#main-flyout .flyout-item");
  const flyoutOverlay = document.querySelector("#flyout-overlay");
  let initialOpen = true;
  if (!mobileMenuToggle || mainMenuItems.length === 0 || !flyout || flyoutItems.length === 0 || !flyoutOverlay) {
    return;
  }
  for (const menuItem of mainMenuItems) {
    menuItem.addEventListener("mouseover", () => menuItemCallback("mouseover"), {
      passive: true
    });
    menuItem.addEventListener("click", () => menuItemCallback("click"), {
      passive: true
    });
    if (menuItem.querySelector('.current')) {
      menuItem.classList.add('has-current');
    }
    function menuItemCallback(event) {
      const mobileMouseover = event === "mouseover" && window.innerWidth < 768;
      const mobileClick = event === "click" && window.innerWidth < 768 && !menuItem.dataset.identifier;
      const desktopClick = event === "click" && window.innerWidth > 767;
      const menuLevel = Number(menuItem.dataset.level || 0);
      const desktopLevel = event === "mouseover" && window.innerWidth > 767 && menuLevel > 1;
      if (mobileMouseover || mobileClick || desktopClick || desktopLevel) return;
      const identifier = menuItem.dataset.identifier;
      identifier ? openFlyout(identifier) : closeFlyout();
    }
  }
  mobileMenuToggle.addEventListener("click", () => {
    const identifier = mobileMenuToggle.dataset.identifier;
    if (mobileMenuToggle.classList.contains("active")) closeFlyout();else if (identifier) openFlyout(identifier);
  }, {
    passive: true
  });
  flyoutOverlay.addEventListener("mouseover", closeFlyout, {
    passive: true
  });
  document.addEventListener("keydown", event => {
    if (event.key === "Escape") closeFlyout();
  }, {
    passive: true
  });
  window.addEventListener("resize", () => {
    adjustFlyoutHeight();
    const mobileMenuOpen = header.querySelector("#mobile-menu.active") || false;
    if (window.innerWidth >= 640 && mobileMenuOpen) closeFlyout();
  });
  function openFlyout(identifier) {
    for (const menuItem of mainMenuItems) {
      toggleElementByIdentifier(menuItem, identifier);
    }
    for (const flyoutItem of flyoutItems) {
      toggleElementByIdentifier(flyoutItem, identifier);
    }
    function toggleElementByIdentifier(element, identifier) {
      element.classList.toggle("active", element.dataset.identifier === identifier);
    }
    if (!initialOpen) adjustFlyoutHeight();
    flyout.classList.add("active");
    flyoutOverlay.classList.add("active");
    mobileMenuToggle.classList.add("active");
    initialOpen = false;
  }
  function adjustFlyoutHeight() {
    const activeFlyoutItem = [...flyoutItems].filter(item => item.classList.contains("active"))[0];
    if (!activeFlyoutItem) return;
    const currentFlyoutItemHeight = activeFlyoutItem.querySelector(".flyout-item-container")?.scrollHeight || "0fr";
    for (const flyoutItem of flyoutItems) {
      flyoutItem.style.setProperty("--flyout-item-height", `${currentFlyoutItemHeight}px`);
    }
  }
  function closeFlyout() {
    for (const menuItem of mainMenuItems) {
      menuItem.classList.remove("active");
    }
    flyout.classList.remove("active");
    flyoutOverlay.classList.remove("active");
    mobileMenuToggle.classList.remove("active");
  }
}